import SideBar from "./SideBar";
import {
  Person2,
  Schedule,
  School,
  Payment,
  Subject,
  CalendarMonth,
  Man,
  MeetingRoom,
  Groups,
  EventNote,
  Grade,
  MonetizationOn,
  CurrencyRupee,
  GridView,
} from "@mui/icons-material";
import { isAuthenticated } from "../../ApiService/ApiService";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate("/login");
    }
  }, []);

  const userRole = sessionStorage.getItem("role");
  // console.log(userRole);

  const superAdminSidebarOptions = [
    { text: "Profile", icon: <Person2 /> },
    { text: "Schools", icon: <School /> },
    { text: "Plans", icon: <Payment /> },
    // Other options for ROLE_SUPER_ADMIN
  ];
  const schoolAdminSidebarOptions = [
    // { text: "Section", icon: <AbcIcon /> },

    { text: "DashBoard", icon: <Groups /> },
    { text: "Subjects", icon: <Subject /> },
    { text: "Academic Sessions", icon: <CalendarMonth /> },
    { text: "Grades", icon: <Grade /> },
    { text: "Teachers", icon: <Man /> },
    { text: "Time Intervals", icon: <Schedule /> },
    { text: "Classes", icon: <MeetingRoom /> },
    { text: "Students", icon: <Groups /> },
    { text: "Holidays", icon: <EventNote /> },
    { text: "Fees", icon: <MonetizationOn /> },
    { text: "Expense Category", icon: <GridView/> },
    { text: "Expense", icon: <CurrencyRupee /> },
    { text: "School Logo", icon: <School /> },
    { text: "Profile", icon: <Person2 /> },
    // Other options for ROLE_SCHOOL_ADMIN
  ];

  const sideNavOptions =
    userRole === "ROLE_SUPER_ADMIN"
      ? superAdminSidebarOptions
      : schoolAdminSidebarOptions;

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <SideBar sideNavOptions={sideNavOptions} />
    </div>
  );
}

export default Dashboard;
